import glb_sv from "../service/globalSv";
export default class inputPrmRq {
  constructor() {
    this.comp_id = glb_sv.sessionInfo.comp_id || 100; //-- AA = 100
    this.branch_id = glb_sv.sessionInfo.branch_id || 0;
    this.user_id = glb_sv.sessionInfo.user_id ||  0; // -- userId
    this.token = glb_sv.userInfo.token; // -- dev
    this.timeout = 15;
    this.lang = glb_sv.language;
    this.client_seq = 0;
    // this.clientChanel = '01' //-- web client, 02 mobile web client, 03 android + ios app
    this.client_tp = glb_sv.client_tp; // # 01 mobile android, 02 mobile iso, 03 mobile web, 04 website, 05 desktop app
    this.client_sent_time = new Date();
    this.msg_tp = 1; //-- 0: -> request to IOT device, 1: request to process logic at server
    this.biz = "";
    this.object = "";
    this.funct = ""; //-- if it's request to IOT device => funct = topic
    this.input = [];
    this.test = false;
    this.uid_exp = glb_sv.sessionInfo.uid_exp
  }
}
